import { useGalleryList } from '@/features/store-management/basic-stores/hooks/useGetGalleryList';
import { HostNameGalleryTable } from '@/features/store-management/basic-stores/host-management/gallery-management/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['createdDate']),
  desc: z.boolean(),
});

const GalleryManagementSearchSchema = z.object({
  breadcrumbReturnTo: z.string().optional(),

  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  q: z.string().optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute(
  '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/',
)({
  component: RouteComponent,

  validateSearch: (search: SearchSchemaInput) => GalleryManagementSearchSchema.parse(search),
});

function RouteComponent() {
  const { getGalleryList, isLoading, pagination, hostId } = useGalleryList();
  return (
    <HostNameGalleryTable data={getGalleryList} isLoading={isLoading} pagination={pagination} commonHostId={hostId} />
  );
}
